module.exports = "<div class=\"space-6\"></div>\n\n<div class=\"row\">\n\t<div class=\"col-sm-12\">\n\n\t\t<button *ngIf=\"!isView\" type=\"button\" class=\"btn btn-primary\" (click)=\"onSubmit.emit()\">\n\t\t\t<i class=\"ace-icon fa fa-save\"></i> Save\n\t\t</button>\n\n\t\t<button type=\"button\" class=\"btn\" (click)=\"onCancel.emit()\">\n\t\t\t<ng-container *ngIf=\"isView\">Back</ng-container>\n\t\t\t<ng-container *ngIf=\"!isView\">Cancel</ng-container>\n\t\t</button>\n\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/form-submit-buttons/form-submit-buttons.html
// module id = 532
// module chunks = 0